import {
  Component,
  ContentChild,
  Input,
  OnInit,
  TemplateRef,
} from '@angular/core';

@Component({
    selector: 'pr-list-item-column',
    template: '',
    standalone: false
})
export class PrListItemColumnComponent {
  @Input() label: string;
  @Input() name: string;
  @Input() priority: number;
  @Input() bold: boolean;

  @ContentChild('header') headerTemplate: TemplateRef<unknown>;
  @ContentChild('value') valueTemplate: TemplateRef<unknown>;
  @ContentChild('before') beforeTemplate: TemplateRef<unknown>;

  constructor() {}
}
